<div *ngIf="!hideCard" class="client-details-card cash-value">
  <div *ngIf="!forClient" class="cash-value_title">
    CASH SURRENDER VALUE &nbsp;
    <basic-tooltip position="above">
      <div label>
        <cp-icon label class="question-mark" type="question-mark-header" class="tooltip-label"></cp-icon>
      </div>
      <div tip>
        The amount your client will receive if they surrender their policy.
        <br />
        Updates daily.
      </div>
    </basic-tooltip>
  </div>
  <div *ngIf="isLoading && !forClient" class="placeholder-loading"></div>
  <div *ngIf="!isLoading && netValueInt === '$0'" class="cash-value_net_value">{{ netValueInt }}</div>
  <cp-popover *ngIf="!isLoading && netValueInt !== '$0'" class="cash-value-help_popover">
    <div label class="cash-value_net_value">{{ netValueInt }}</div>
    <div content>
      <ul class="popover-list">
        <li>
          <div class="popover-row">
            <span>
              Guaranteed cash value &nbsp;
              <basic-tooltip *ngIf="forClient" position="above">
                <div label>
                  <div class="tooltip"></div>
                </div>
                <div tip>The minimum amount of cash value in your policy before any dividends have been paid.</div>
              </basic-tooltip>
            </span>
            <span>{{ guaranteedCashValue }}</span>
          </div>
        </li>
        <li>
          <div *ngIf="dividendEnabled" class="popover-row">
            <span>
              Dividend accumulations &nbsp;
              <basic-tooltip *ngIf="forClient" position="above">
                <div label>
                  <div class="tooltip"></div>
                </div>
                <div tip>The amount of dividends paid in cash and currently earning interest.</div>
              </basic-tooltip>
            </span>
            <span>
              {{ dividend }}
            </span>
          </div>
          <div *ngIf="!dividendEnabled" class="popover-row">
            <span>
              Cash value from paid-up additions &nbsp;
              <basic-tooltip *ngIf="forClient" position="above">
                <div label>
                  <div class="tooltip"></div>
                </div>
                <div tip>
                  The amount of cash value from the additional paid-up life insurance on your policy, which is purchased
                  either with dividends or with the Additional Life Insurance Rider.
                </div>
              </basic-tooltip>
            </span>
            <span>
              {{ cashValueFromPaidUpAdditions }}
            </span>
          </div>
        </li>
        <li>
          <div class="popover-row">
            <span>
              Unearned premium &nbsp;
              <basic-tooltip *ngIf="forClient" position="above">
                <div label>
                  <div class="tooltip"></div>
                </div>
                <div tip>The amount of premium already paid on the policy, but not yet applied towards the policy.</div>
              </basic-tooltip>
            </span>
            <span>
              {{ unearnedPremium }}
            </span>
          </div>
        </li>
        <li>
          <hr class="cash-value-separator" />
        </li>
        <li *ngIf="loanEnabled">
          <div class="popover-row popover-gross_cash_value">
            <span>Gross cash value</span>
            <span>
              {{ grossCashValue }}
            </span>
          </div>
        </li>
        <li *ngIf="loanEnabled">
          <div class="popover-row">
            <span>
              Outstanding loan + interest &nbsp;
              <basic-tooltip *ngIf="forClient" position="above">
                <div label>
                  <div class="tooltip"></div>
                </div>
                <div tip>
                  The total amount of debt against your policy. Like any other loan, your policy loan will continue to
                  accrue interest and can be re-paid at any time.
                </div>
              </basic-tooltip>
            </span>
            <span>
              {{ outstandingLoanInterest }}
            </span>
          </div>
        </li>
        <li *ngIf="loanEnabled">
          <hr class="cash-value-separator" />
        </li>
        <li>
          <div class="popover-row popover-net_value">
            <span>Cash surrender value</span>
            <span>{{ netValue }}</span>
          </div>
        </li>
      </ul>
    </div>
  </cp-popover>
</div>
